export default __webpack_public_path__ + "static/media/CapaLogoDarkSolid.42d34a9b.png";